module.exports = __webpack_public_path__ + "static/img/yqxyqy.ee31ab10.png";